import { Theme } from "@mui/material";
import { prettyPrintDaysFromInt } from "./dates";

export interface DaysInTransitInfo {
  display: string;
  color: string | undefined;
  tooltipText: string;
}

export const DAYS_IN_TRANSIT_TOOLTIP_TEXT =
  "Days In Transit shows the number of days between the Ship Date and the date the TSDF received the waste shipment as recorded in EPA's e-Manifest system";

/**
 * Get display info for Days In Transit.
 * Returns null if eManifestDaysInTransit is null (database handles regulated manifest check).
 * Color coding (red >= 60 days, warning >= 45 days) only applies when manifest is still outstanding (not yet received).
 */
export const getDaysInTransitInfo = (
  eManifestDaysInTransit: number | null | undefined,
  receivedDate: string | null | undefined,
  theme: Theme
): DaysInTransitInfo | null => {
  // Return null if no value (non-regulated, vendor-only, or missing data - handled by database view)
  if (eManifestDaysInTransit == null) {
    return null;
  }

  const display = prettyPrintDaysFromInt(eManifestDaysInTransit);

  // Only apply warning/error color coding when manifest is still outstanding (not yet received)
  let color: string | undefined = undefined;
  if (!receivedDate) {
    if (eManifestDaysInTransit >= 60) {
      color = theme.palette.error.main;
    } else if (eManifestDaysInTransit >= 45) {
      color = theme.palette.warning.main;
    }
  }

  // Different tooltip based on received status
  const tooltipText = receivedDate
    ? DAYS_IN_TRANSIT_TOOLTIP_TEXT
    : "This manifest has not yet been received by the TSDF. The days in transit will update daily until the manifest is received.";

  return {
    display,
    color,
    tooltipText,
  };
};
